import React from 'react';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import MailActions from 'actions/inbox/MailActions';
import MailRowContent from 'components/inbox/mail-table/MailRowContent';
import classNames from 'classnames';
import './MailTableRow.styl';

export default class MailTableRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onCheck = this.onCheck.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  onDragStart(e) {
    e.dataTransfer.setData('text/plain', JSON.stringify(this.props.item.toJS()));
    e.dataTransfer.setDragImage(this.ref, 0, 0);
    e.dataTransfer.effectAllowed = 'move';
  }

  onCheck(e) {
    e.stopPropagation();

    const itemsToCheck = this.props.item.isGrouped
      ? this.props.item.groupedItems
      : [this.props.item];

    itemsToCheck.map(item =>
      MailActions[this.props.isSelected ? 'unselectMail' : 'selectMail'](item)
    );
  }

  render() {
    const {item, isSelected} = this.props;

    return (
      <div
        ref={r => (this.ref = r)}
        onDragStart={this.onDragStart}
        draggable
        className={classNames('mail-table-row', {
          unread: !item.viewedDate,
        })}>
        <CheckboxField onClick={this.onCheck} checked={isSelected} />
        <MailRowContent item={item} filters={this.props.filters} />
      </div>
    );
  }
}
